<script lang="ts">
  import { CloseActions } from "./UnsignedMattersState.svelte";
  import WaitButton from "../WaitButton.svelte";
  import Gift from "~icons/ph/gift";

  let {
    manager
  } = $props();

  let nextType = $derived(manager.nextSignableMatterType?.toUpperCase());
  let plural = $derived(manager.mattersSigned.length > 1);
</script>

<h2 class="ui-title mb-2">Congratulations!</h2>
<p class="text-base mb-3">
  We will get to work on your {plural ? "claims" : "claim"} straight away.
  You can download your signed contract and client care pack
  {plural ? "for each claim using the links below" : "using the link below"}.
  We will also send you a copy via email.
</p>
<div class="-mx-1">
  {#each manager.mattersSigned as matter (matter.sfid)}
    {@const {title, contract_url} = matter}
    <a class="flex items-start p-2.5 border-2 border-solid border-success bg-success-200 rounded gap-3 text-sm text-left mb-3" target="_blank" href={contract_url}>
      <Gift class="w-10 h-10 shrink-0" />
      <p>
        <b class="text-medium">{title}</b><br>
        <span class="underline">Download client care pack</span>
      </p>
    </a>
  {/each}
</div>
<div class="floating-footer">
  <WaitButton type="button" class="btn only:btn-primary only:ml-auto only:grow sm:only:grow-0" onclick={() => manager.doSuccess(CloseActions.VIEW_SIGNED)}>
    Go to your {plural ? "claims" : "claim"}
  </WaitButton>
  {#if nextType}
    <WaitButton type="button" class="btn btn-primary" onclick={() => manager.doSuccess(CloseActions.CONTINUE_SIGNING)}>
      Go to {nextType} offers
    </WaitButton>
  {/if}
</div>
